import { FileText, Plus } from "lucide-react";
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@repo/ui";

interface NotesCellProps {
  hasNotes: boolean;
  onClickNotes: () => void;
}

export function NotesCell({ hasNotes, onClickNotes }: NotesCellProps) {
  const Icon = hasNotes ? FileText : Plus;
  const tooltipText = hasNotes ? "View notes" : "Add note";

  return (
    <div className="flex items-center justify-center">
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="h-8 w-8 p-0"
              onClick={onClickNotes}
            >
              <Icon
                className={`h-4 w-4 ${hasNotes ? "text-primary" : "text-muted-foreground"} hover:text-primary`}
              />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{tooltipText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
